import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class CommandResultsApi extends CollectionApi {
  constructor() {
    super('/api/commandresults', {
      skip: 0,
      limit: 100,
      sort: '-responseTime', // Prepend with a '-' to reverse default sort direction
      search: {
        fields: ['name'],
        searchTerm: '',
      },
    });
    this.baseUrl = '/api/commandresults';
  }

  async search(payload) {
    await this.initialize();
    return axios.post('/api/search/commandresults', payload);
  }
}

export default new CommandResultsApi();
